export default __webpack_public_path__ + "static/wsg-gb-02-dad2827a4169c074024eec47dac92e20.jpg";